


















import { BButton } from "bootstrap-vue";
import { useNow } from "@vueuse/core";
import { DateTime } from "luxon";
import { computed } from "@vue/composition-api";
import useEngageForm from "@/views/modules/engage/useEngageForm";
import useCampaigns from "@/views/modules/engage/useCampaigns";

export default {
    components: { BButton },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    setup(props, context) {
        const { deleteCampaign } = useCampaigns(context.root.$bvModal);
        const { now } = useNow({ controls: true });
        const { editCampaign } = useEngageForm(context.root.$bvModal);
        const dateIsPast = computed(() => {
            return DateTime.fromISO(props.data.item.sendAt) < DateTime.fromJSDate(now.value);
        });
        const deleteOneCampaign = async (campaignId) => {
            await deleteCampaign(campaignId);
        };
        return {
            editCampaign,
            deleteOneCampaign,
            dateIsPast,
        };
    },
};
